export default [
   {
      fileName: "client/banner_campanie_vn.png",
      link: "https://upromania.ro/fisiere/Regulament_concurs_crestere-tichet-de-masa.pdf",
      category: "Banner",
      action: "Click",
      label: "Client_concurs_vn",
    },
  {
    fileName: "client/banner_emi.jpg",
    link: "https://emi.ro/servicii/",
    category: "Banner",
    action: "Click",
    label: "Client_Emi",
  },
  {
    fileName: "client/banner_kadra.jpg",
    link: "https://kadra.ro/service-si-mentenanta/",
    category: "Banner",
    action: "Click",
    label: "Client_Kdra",
  },
  {
    fileName: "client/vn-dejun3.png",
    link: "https://upromania.ro/companii/card-de-tichete-de-masa-up-dejun/",
    category: "Banner",
    action: "Click",
    label: "Client_vn_dejun_45",
  },
];
